import { Icon, type IconProps } from './Icon';

/** Voltar, no cabeçalho. Substitui o `‹`. */
export function ChevronLeftIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="m15 18-6-6 6-6" />
    </Icon>
  );
}
